// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"400":"6383cb82","747":"b940a129","888":"31d3e3e3"}[chunkId] + ".chunk.js";
};